import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'Common/Components/Checkbox';
import { get } from 'lodash';
import { selectCredentialsList, selectCredentialsSelected, selectShowDetail } from 'store/Credentials/selectors';
import { credentialsUnselected, multipleSelectionCredentials, selectAllCredentials, unselectAllCredentials } from 'store/Credentials/actions';
import Skeleton from 'Common/Components/Skeleton';

const SelectedCell = ({ rowInfo, isHeader, showSkeleton }) => {
  const dispatch = useDispatch();
  const showDetail = useSelector(selectShowDetail);
  const data = get(rowInfo, 'original', {});
  const rowId = get(rowInfo, 'original.value.id', '');
  const credentials = useSelector(selectCredentialsList);
  const credentialsSelected = useSelector(selectCredentialsSelected);
  const isSelected = credentialsSelected.some((e) => e.id === rowId);

  const allCredentialsSelected = credentials.length === credentialsSelected.length;

  const rowClick = () => {
    if (isSelected) dispatch(credentialsUnselected(data));
    else dispatch(multipleSelectionCredentials(data));
  };

  const headerClick = () => {
    if (allCredentialsSelected) {
      dispatch(unselectAllCredentials());
    } else {
      dispatch(selectAllCredentials());
    }
  };

  const onClick = isHeader ? headerClick : rowClick;

  if (showSkeleton) return <Skeleton />;
  return (
    <Checkbox disabled={ showDetail } theme="grey" onChange={ onClick } state={ isHeader ? allCredentialsSelected : isSelected } partialChecked={ isHeader && !allCredentialsSelected && credentialsSelected?.length > 0 } />
  );
};

export default SelectedCell;
